exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-26ceff2a] .el-dialog__body{height:500px;padding:10px 20px}", ""]);

// exports
